import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mv-sheet-loading"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mv-lbl-opt-name" }
const _hoisted_4 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#9CA3AF","flex-shrink":"0"},
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_5 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}

import type { LabelItem } from '@/types/chat'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileLabelsSheet',
  props: {
    open: { type: Boolean },
    allLabels: {},
    currentLabels: {},
    protectedTitles: {}
  },
  emits: ["close", "toggle"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mv-sheet-overlay",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createElementVNode("div", {
            class: "mv-sheet",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mv-sheet-handle" }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mv-sheet-title" }, "Etiquetas", -1)),
            (!__props.allLabels.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", {
                    class: "mv-spinner",
                    style: {"width":"22px","height":"22px","border-width":"2px"}
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.allLabels, (lbl) => {
              return (_openBlock(), _createElementBlock("label", {
                key: lbl.id,
                class: _normalizeClass(["mv-lbl-opt", { checked: __props.currentLabels.includes(lbl.title) }]),
                onClick: _withModifiers(($event: any) => ((__props.currentLabels.includes(lbl.title) && __props.protectedTitles.has(lbl.title)) || _ctx.$emit('toggle', lbl.title)), ["prevent"])
              }, [
                _createElementVNode("span", {
                  class: "mv-lbl-dot",
                  style: _normalizeStyle({ background: lbl.color })
                }, null, 4),
                _createElementVNode("span", _hoisted_3, _toDisplayString(lbl.title.replace(/_/g, ' ')), 1),
                (__props.currentLabels.includes(lbl.title) && __props.protectedTitles.has(lbl.title))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "11",
                        width: "18",
                        height: "11",
                        rx: "2"
                      }, null, -1),
                      _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                    ]))]))
                  : (__props.currentLabels.includes(lbl.title))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
              ], 10, _hoisted_2))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})